import FilesIndex from '@/views/FilesIndex.vue';

const routes = [
    {
        path: '/files',
        name: 'FilesIndex',
        component: FilesIndex,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
